import { render, staticRenderFns } from "./attorney-closing-items.vue?vue&type=template&id=c43247cc"
import script from "./attorney-closing-items.vue?vue&type=script&lang=js"
export * from "./attorney-closing-items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports